module.exports = __webpack_public_path__ + "static/media/coin3.431ab039.png";